export const NoInternetIcon = () => {
  return (
    <svg
      width="290"
      height="290"
      viewBox="0 0 290 290"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M168.91 137.54C151.068 131.785 146.79 113.775 146.79 113.775C147.389 112.919 147.974 112.053 148.545 111.178L149.122 101.887C139.802 99.3098 145.092 87.9611 145.092 87.9611C140.818 81.7145 137.251 75.0128 134.456 67.979C129.281 68.4832 124.324 70.3144 120.065 73.2955C123.627 85.1881 129.643 99.871 142.427 119.433C136.926 126.301 127.946 137.159 123.621 142.806L89.1394 127.368L81.2793 143.625L119.983 163.443C122.656 164.693 125.681 164.972 128.538 164.232C131.395 163.491 133.904 161.778 135.633 159.386L144.104 147.708C147.503 152.917 150.107 157.193 159.541 161.14C169.577 156.624 173.923 151.155 177.687 143.625C174.43 142.123 171.46 140.063 168.91 137.54Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M169.377 207.793L167.979 200.145L200.651 194.116L202.049 201.762L169.377 207.793Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M197.966 201.351L192.84 195.541L220.443 171.2L225.567 177.01L197.966 201.351Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M72.48 85.1028C71.906 85.0865 71.3343 85.1835 70.7977 85.3881C70.2611 85.5927 69.77 85.9011 69.3526 86.2955C68.9351 86.6899 68.5994 87.1627 68.3647 87.6868C68.1299 88.211 68.0007 88.7762 67.9844 89.3503C67.9681 89.9244 68.0651 90.496 68.2697 91.0326C68.4743 91.5693 68.7827 92.0603 69.1771 92.4778C69.5715 92.8952 70.0443 93.2309 70.5684 93.4657C71.0926 93.7004 71.6578 93.8296 72.2319 93.8459C73.3913 93.8788 74.5163 93.4498 75.3594 92.6532C76.2025 91.8567 76.6946 90.7578 76.7275 89.5984C76.7604 88.439 76.3314 87.314 75.5348 86.471C74.7383 85.6279 73.6394 85.1357 72.48 85.1028Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M76.0436 64.9836C77.2135 63.2072 77.929 61.1705 78.1273 59.0527C78.3256 56.9348 78.0006 54.8007 77.1808 52.838C76.3611 50.8752 75.0717 49.1439 73.426 47.7962C71.7803 46.4485 69.8288 45.5258 67.7429 45.109C65.6571 44.6923 63.5008 44.7944 61.4636 45.4063C59.4265 46.0183 57.5708 47.1213 56.0598 48.6184C54.5489 50.1156 53.4288 51.961 52.7982 53.9924C52.1675 56.0239 52.0456 58.1791 52.4431 60.2687C52.4763 60.4909 52.521 60.7102 52.5802 60.9266L58.8835 59.7493C58.6228 58.89 58.5403 57.9866 58.641 57.0943C58.7418 56.2019 59.0236 55.3396 59.4694 54.5601C59.9151 53.7805 60.5153 53.1002 61.2332 52.5608C61.9511 52.0213 62.7715 51.6342 63.6443 51.423C64.5171 51.2118 65.4238 51.181 66.3089 51.3326C67.194 51.4841 68.0389 51.8148 68.7917 52.3043C69.5445 52.7939 70.1894 53.432 70.6869 54.1795C71.1844 54.9271 71.5241 55.7683 71.6851 56.6518C72.2622 59.7984 70.5525 62.2136 68.423 64.8754C67.0249 66.5423 66.2587 68.6483 66.2589 70.8239C66.2675 74.073 66.6542 77.3119 67.4131 80.4716L73.9055 79.238C73.2089 76.3316 72.9046 73.345 73.0009 70.3579C73.412 68.2731 74.9197 66.6832 76.0436 64.9836Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.3854 11.5486C69.9117 10.2615 80.5898 11.864 90.2746 16.1841C108.909 24.4857 120.356 40.6763 123.771 58.3629C123.771 58.3629 123.855 60.7464 124.035 62.583C122.897 63.2697 120.656 61.361 118.698 59.6917C116.932 58.1869 115.396 56.8783 115.107 57.8493C114.83 58.7828 115.497 59.7826 116.556 61.3696C117.977 63.4991 120.102 66.6847 121.6 72.1859L120.157 73.3589C120.594 75.1075 121.628 78.0478 122.845 81.5104L123.344 82.9344C120.923 93.403 115.563 103.372 107.094 111.525C99.8608 118.522 90.9426 123.531 81.2041 126.068C80.9877 126.126 79.5132 125.168 77.7602 124.03C75.3638 122.472 72.4466 120.577 71.5088 120.473C70.0213 120.307 73.5387 124.845 75.058 126.807C75.1965 126.983 75.3176 127.139 75.4158 127.269C67.7514 128.466 59.9253 128.125 52.3941 126.266C44.8628 124.407 37.7773 121.066 31.5509 116.439C25.3245 111.812 20.0819 105.992 16.1291 99.3172C12.1762 92.6425 9.5922 85.2475 8.52785 77.5635C7.46351 69.8795 7.94012 62.0605 9.92989 54.5627C11.9197 47.0648 15.3827 40.0384 20.117 33.8932C24.8514 27.7481 30.7621 22.6074 37.5044 18.771C44.2467 14.9346 51.6841 12.4794 59.3854 11.5486ZM60.9233 24.0529C69.158 23.0457 77.5115 24.2991 85.088 27.6785C114.941 40.9778 121.207 80.16 98.2458 102.261C93.0363 107.301 86.7026 111.03 79.7678 113.139C72.8331 115.248 65.4961 115.677 58.3626 114.391C51.2292 113.105 44.504 110.141 38.7422 105.743C32.9804 101.345 28.3473 95.64 25.2255 89.0983C22.1037 82.5566 20.5827 75.3662 20.7881 68.1207C20.9935 60.8752 22.9193 53.7825 26.4067 47.4281C29.894 41.0738 34.8428 35.6401 40.8445 31.5756C46.8462 27.5112 53.7285 24.9327 60.9233 24.0529Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M225.65 187.619L228.994 182.548L223.841 178.491L221.128 180.93L225.65 187.619Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M243.358 193.765L239.03 203.72C237.724 206.753 235.475 209.283 232.615 210.934L254.216 227.775L266.935 212.097L243.358 193.765Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M220.58 117.886C224.179 118.389 227.834 117.476 230.773 115.339C233.713 113.202 235.709 110.007 236.341 106.428C231.904 105.001 227.228 104.477 222.586 104.887C217.944 105.296 213.431 106.631 209.313 108.813C210.199 111.2 211.714 113.304 213.697 114.901C215.68 116.499 218.058 117.53 220.58 117.886Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M137.991 112.404L118.037 96.8901C115.168 102.971 111.016 108.359 105.867 112.682L131.548 132.939L142.458 119.426L137.991 112.404Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M148.956 104.729L152.875 101.962C151.632 102.043 150.385 102.015 149.148 101.879L148.956 104.729Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M175.022 119.01C175.311 116.8 174.809 114.559 173.605 112.683C172.402 110.807 170.574 109.417 168.445 108.758C168.717 107.975 168.802 107.14 168.692 106.318C166.882 93.107 164.141 84.9656 159.618 80.307C156.548 77.0983 150.272 77.6206 146.544 82.3066C142.842 86.9999 143.772 93.1907 143.748 93.7043C144.123 89.0926 146.276 84.8072 149.751 81.7526C150.724 80.954 151.868 80.3911 153.094 80.1079C152.902 84.276 156.219 90.8809 160.221 89.2361C162.897 88.144 163.219 92.9873 157.946 92.9873C156.521 104.417 156.959 117.514 162.222 128.183L163.072 129.799C165.659 134.511 169.357 138.519 173.845 141.477C176.826 141.632 179.746 140.598 181.964 138.6C184.182 136.603 185.516 133.807 185.673 130.826C185.828 127.846 184.793 124.926 182.796 122.708C180.799 120.49 178.003 119.167 175.022 119.01Z"
        fill="var(--textAndLabels-main)"
      />
      <path
        d="M225.65 187.619L228.994 182.548L223.84 178.491L221.128 180.93L225.65 187.619Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinejoin="round"
      />
      <path
        d="M243.358 193.765L239.03 203.72C237.724 206.753 235.475 209.283 232.615 210.934L254.216 227.775L266.935 212.097L243.358 193.765Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
      />
      <path
        d="M137.991 112.404L118.036 96.8901C115.168 102.971 111.016 108.359 105.867 112.682L131.548 132.939L142.458 119.426L137.991 112.404Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
      />
      <path
        d="M144.68 87.3781C140.54 81.3261 137.118 74.8136 134.482 67.9717C129.306 68.4739 124.349 70.308 120.092 73.2954C123.656 85.1909 129.658 99.8565 142.455 119.427"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.478 65.011C123.71 61.0121 123.415 56.9366 123.601 52.8688C123.519 50.7669 123.664 48.6622 124.034 46.5914C125.044 40.9113 126.427 41.4653 126.885 46.9477C128.003 60.3769 131.213 64.8191 132.393 68.273"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.791 48.3184C122.872 46.38 121.682 44.5826 120.255 42.9803C119.822 42.5648 118.813 42.5229 120.063 45.9956C120.332 46.7372 121.404 49.943 121.736 51.0943C122.505 53.3911 123.128 55.7346 123.6 58.1104"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.985 61.8039C123.793 64.5177 119.602 60.3207 117.625 58.7337C115.846 57.3054 113.297 56.3979 116.885 61.5846C119.011 64.8937 120.62 68.5081 121.655 72.3028"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M227.596 190.47L221.128 180.93"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M149.184 101.809C149.184 101.809 148.881 105.606 148.579 111.171C147.974 112.029 147.38 112.894 146.798 113.768"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.876 102.044L148.968 104.696"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M194.211 194.307L172.31 170.159"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M210.437 179.998C201.928 166.322 189.57 155.462 174.914 148.779"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.258 199.725L159.618 161.113"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.391 198.336L202.049 201.762L169.377 207.793L167.979 200.145L192.84 195.568"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.817 141.515C176.754 141.593 179.605 140.521 181.763 138.529C183.921 136.537 185.217 133.781 185.374 130.847C185.531 127.914 184.537 125.036 182.604 122.824C180.67 120.613 177.95 119.244 175.022 119.008C175.311 116.798 174.809 114.557 173.605 112.681C172.402 110.805 170.574 109.414 168.445 108.755C169.332 106.183 166.588 90.0171 161.646 82.8004C157.009 76.0282 150.231 77.6137 146.516 82.3041C142.801 86.9945 143.745 93.1868 143.72 93.7018"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.65 187.619L244.317 159.221C247.879 153.492 247.742 151.683 249.332 147.737C256.788 143.68 273.7 138.91 282.061 137.814C275.921 147.408 261.531 153.081 255.856 164.978L238.999 203.681C238.003 205.974 236.467 207.991 234.521 209.56C232.575 211.128 230.278 212.202 227.827 212.69C225.375 213.177 222.842 213.063 220.444 212.359C218.046 211.654 215.854 210.379 214.056 208.643L202.433 197.433"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M197.966 201.351L192.84 195.541L220.443 171.201L225.567 177.011L197.966 201.351Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.0267 129.535C78.0146 129.234 73.0472 124.496 72.2306 123.043C71.1269 121.074 69.9568 118.793 75.1089 122.412C79.2828 125.047 83.6122 127.427 88.0735 129.538"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M174.64 206.806L176.914 214.975C178.397 220.224 181.868 224.688 186.59 227.419C191.305 230.16 234.367 250.827 234.367 250.827C245.852 257.32 250.539 272.043 259.694 278.841C259.173 270.426 255.555 253.212 252.019 245.514C248.246 243.681 246.409 243.674 241.165 239.923L200.021 211.005L197.665 202.562"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.971 134.195C152.41 136.224 143.048 149.178 135.634 159.413C133.902 161.802 131.393 163.514 128.537 164.253C125.681 164.993 122.656 164.715 119.983 163.467L81.2795 143.652L89.118 127.398L123.6 142.803"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M168.911 137.54C171.477 140.054 174.447 142.122 177.695 143.658C174.06 152.026 167.839 157.444 159.563 161.167C150.103 157.207 147.513 152.971 144.098 147.74"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.853 172.571C201.872 149.81 183.878 146.208 177.696 143.658"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.791 113.775C146.791 113.775 151.067 131.783 168.911 137.54C166.159 134.826 163.888 131.665 162.195 128.192C156.919 117.537 156.493 104.427 157.918 92.9976H158.631C162.959 92.7509 162.879 88.1428 160.194 89.2465C156.19 90.8869 152.876 84.2848 153.068 80.1196C151.842 80.405 150.698 80.9671 149.724 81.7629C147.697 83.5378 146.107 85.7569 145.079 88.2472C144.05 90.7375 143.611 93.4318 143.795 96.1197C144.306 99.604 146.705 102.388 152.876 102.048"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M146.79 113.775C144.214 117.67 124.122 141.487 121.436 145.846"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.8047 132.66C63.4889 132.825 60.7766 133.374 59.9802 133.537C56.3632 134.282 56.8292 135.237 57.4048 135.292C59.7334 135.512 63.5163 135.485 65.6819 135.758C69.1633 136.198 75.8793 136.827 78.5108 138.389"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.49 135.73C64.9129 135.95 64.3935 136.142 64.1468 136.251C60.6928 137.567 61.3247 138.451 61.899 138.415C64.2304 138.278 67.9585 137.594 70.1501 137.511C72.7857 137.462 75.42 137.664 78.0174 138.114"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M165.621 56.981C165.579 57.6862 165.328 58.363 164.9 58.9253C164.472 59.4877 163.887 59.9102 163.219 60.1392C162.72 60.3107 162.189 60.3695 161.664 60.3112C161.139 60.2528 160.634 60.0789 160.185 59.8019C159.735 59.5248 159.353 59.1516 159.065 58.709C158.777 58.2665 158.591 57.7656 158.52 57.2425C158.449 56.7194 158.495 56.187 158.654 55.6837C158.814 55.1805 159.083 54.7188 159.442 54.332C159.801 53.9452 160.242 53.6429 160.732 53.4468C161.222 53.2507 161.75 53.1658 162.277 53.1981C163.22 53.2601 164.101 53.6924 164.728 54.401C165.354 55.1095 165.675 56.0368 165.621 56.981Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M260.38 143.214C261.176 135.49 259.374 127.721 255.257 121.136C251.141 114.552 244.946 109.529 237.653 106.862C231.593 104.647 225.037 104.156 218.714 105.444C212.391 106.732 206.549 109.747 201.837 114.156C197.126 118.565 193.729 124.194 192.024 130.417C190.32 136.64 190.374 143.215 192.182 149.409"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.292 174.432C227.215 174.711 231.155 174.311 234.942 173.253"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M224.471 90.0646C222.417 89.7814 220.325 89.957 218.347 90.5786C216.369 91.2003 214.553 92.2526 213.03 93.6599C211.507 95.0672 210.314 96.7945 209.539 98.7176C208.763 100.641 208.423 102.712 208.543 104.782C208.706 107.551 209.686 110.209 211.359 112.422C213.032 114.634 215.323 116.301 217.942 117.212C220.562 118.123 223.393 118.238 226.078 117.541C228.763 116.844 231.181 115.367 233.027 113.297C234.872 111.226 236.062 108.655 236.446 105.907C236.955 102.219 235.979 98.4799 233.734 95.5098C231.489 92.5397 228.158 90.5814 224.471 90.0646Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.834 48.2353C117.338 39.3196 111.706 31.3993 104.431 25.1709C97.1568 18.9425 88.4635 14.5968 79.1158 12.5161C69.768 10.4353 60.0522 10.6831 50.8227 13.2378C41.5932 15.7924 33.1328 20.5757 26.1854 27.1668C19.238 33.758 14.0165 41.9552 10.98 51.0376C7.94349 60.1199 7.18506 69.8093 8.77137 79.2535C10.3577 88.6977 14.2402 97.6075 20.0774 105.199C25.9146 112.791 33.5277 118.833 42.2473 122.792C52.6373 127.427 64.138 128.987 75.3873 127.288"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M123.301 82.8276C121.525 90.5072 118.209 97.7464 113.554 104.107C108.898 110.468 103.001 115.818 96.2178 119.833C91.5307 122.6 86.4737 124.686 81.1987 126.028"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.0883 27.6784C77.512 24.2989 69.1588 23.0454 60.9243 24.0522C52.6898 25.0591 44.8847 28.2884 38.3459 33.3939C31.8072 38.4993 26.7815 45.2883 23.8077 53.0327C20.8339 60.7772 20.0242 69.1851 21.4655 77.3548C22.9068 85.5244 26.5447 93.1477 31.989 99.407C37.4333 105.666 44.4788 110.326 52.3698 112.886C60.2608 115.445 68.6998 115.809 76.7817 113.937C84.8636 112.066 92.2837 108.029 98.2461 102.261C121.208 80.1598 114.942 40.9776 85.0883 27.6784Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4795 165.307L55.6505 174.954L68.0668 155.904"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M150.053 173.777L138.21 175.284"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M144.871 180.464L143.364 168.596"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.729 89.5984C76.7047 90.4633 76.4245 91.3015 75.9237 92.0071C75.423 92.7127 74.7243 93.254 73.9159 93.5625C73.1076 93.8709 72.2259 93.9327 71.3824 93.7401C70.5389 93.5475 69.7715 93.109 69.1772 92.4802C68.5829 91.8514 68.1884 91.0605 68.0436 90.2075C67.8988 89.3544 68.0103 88.4777 68.3638 87.688C68.7174 86.8983 69.2972 86.2312 70.0299 85.771C70.7626 85.3109 71.6153 85.0783 72.4801 85.1028C73.6387 85.1387 74.7359 85.6317 75.5321 86.474C76.3282 87.3164 76.7586 88.4397 76.729 89.5984Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.0163 64.9836C77.1861 63.2072 77.9017 61.1705 78.1 59.0527C78.2983 56.9348 77.9732 54.8007 77.1535 52.838C76.3337 50.8752 75.0443 49.1439 73.3987 47.7962C71.753 46.4485 69.8014 45.5258 67.7156 45.109C65.6297 44.6923 63.4734 44.7944 61.4363 45.4063C59.3991 46.0183 57.5435 47.1213 56.0325 48.6184C54.5215 50.1156 53.4015 51.961 52.7708 53.9924C52.1402 56.0239 52.0183 58.1791 52.4158 60.2687C52.4475 60.4909 52.4937 60.7102 52.5528 60.9266L58.8576 59.7493C58.595 58.8896 58.511 57.9852 58.6105 57.0917C58.7101 56.1983 58.9913 55.3346 59.4368 54.5537C59.8823 53.7729 60.4827 53.0913 61.2012 52.551C61.9196 52.0106 62.7409 51.6227 63.6147 51.4113C64.4885 51.1998 65.3962 51.1692 66.2823 51.3213C67.1683 51.4734 68.0139 51.8051 68.7671 52.2958C69.5203 52.7866 70.1653 53.4261 70.6624 54.1752C71.1594 54.9243 71.4982 55.767 71.6577 56.6518C72.2348 59.7984 70.5252 62.2136 68.3957 64.8754C66.9976 66.5423 66.2314 68.6483 66.2315 70.8239C66.1998 71.9925 66.2517 73.1626 66.3845 74.3254C66.5446 75.8548 67.4103 80.4716 67.4103 80.4716L73.9026 79.238C73.8204 79.238 73.0254 74.0859 72.9706 73.5103C72.8199 72.4649 72.8199 71.4033 72.9706 70.3579C73.3847 68.2731 74.8924 66.6832 76.0163 64.9836Z"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.6211 140.857C78.7829 138.322 74.7182 136.149 70.479 134.364C67.0756 133.12 63.5424 132.265 59.9469 131.815C54.6563 131.166 54.0518 129.742 59.8098 128.964C61.9285 128.707 64.064 128.616 66.1969 128.69C70.2409 128.742 74.2676 129.238 78.2034 130.17"
        stroke="var(--textAndLabels-main)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
